
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/company/[ticker]/[accessionNumber]",
      function () {
        return require("private-next-pages/company/[ticker]/[accessionNumber]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/company/[ticker]/[accessionNumber]"])
      });
    }
  